<div class="organize-teams">
  <div class="organize-teams-body">
    <div class="row organize-teams-row">
      <div class="col-lg-5 organize-teams-column">
        <app-organize-teams-members-panel
          [rows]="workspaceRows"
          [allChecked]="allChecked"
          [searchValue]="searchValue"
          [searching]="searching"
          [showInvite]="showInvite"
          [loadingMembers]="loadingMembers"
          [dragDisabled]="selectedTeam?.loadState !== 'loaded'"
          (searchChange)="onSearchChange($event)"
          (invite)="onInvite()"
          (toggleMember)="onToggleMember($event)"
          (toggleAll)="onToggleAll($event)"
          (loadMore)="onLoadMore()"
          (dropped)="onDrop($event)">
        </app-organize-teams-members-panel>
      </div>
      <div class="col-lg-7 organize-teams-column">
        <app-organize-teams-team-panel
          [teams]="teams"
          [selectedTeam]="selectedTeam"
          [leaders]="leaders"
          [members]="teamMembers"
          [showMembersWarning]="showMembersWarning"
          (selectTeam)="onSelectTeam($event)"
          (retryTeam)="onRetryTeam($event)"
          (dropped)="onDrop($event)"
          (remove)="onRemove($event)">
        </app-organize-teams-team-panel>
      </div>
    </div>
  </div>

  <div class="organize-teams-footer">
    <button type="button" class="copy-invite-link" [class.copy-invite-link--copied]="invitationLinkCopied"
            [disabled]="!selectedTeam" (click)="onCopyInvitationLink()"
            tooltipStyleClass="tooltip-style" [pTooltip]="invitationLinkCopied ? '' : ('invite_team' | translate)">
      <span *ngIf="inviteLinkLoading" class="spinner-border spinner-border-sm copy-invite-icon" role="status"></span>
      <i *ngIf="!inviteLinkLoading" class="bi copy-invite-icon"
         [ngClass]="invitationLinkCopied ? 'bi-patch-check-fill' : 'bi-link-45deg'"></i>
      <span>{{(invitationLinkCopied ? 'copy_link' : 'manage_copy_link') | translate}}</span>
    </button>
    <div class="footer-actions">
      <button type="button" class="btn btn-text" *ngIf="hasPreviousTeam" (click)="onSelectSiblingTeam(-1)">
        {{'organizeteam_previous' | translate}}
      </button>
      <button type="button" class="btn btn-hallow" *ngIf="hasNextTeam" (click)="onSelectSiblingTeam(1)">
        {{'next_team_button' | translate}}
      </button>
      <button type="button" pButton pRipple class="btn primary-btn" [disabled]="!canSave" (click)="onDone()">
        {{'done_button' | translate}}
      </button>
    </div>
  </div>
</div>
